import { Schema as S } from "effect";
export const Schema = S.TemplateLiteral(S.Literal("pk_"), S.String).pipe(S.brand("@open-revenue/schema/PublicApiKey"), S.annotations({
    description: "A unique identifier for a public API key of an application."
}));
export const FromBearerToken = S.compose(S.String.pipe(S.transform(S.String, {
    decode: (token)=>token.replace("Bearer ", ""),
    encode: (token)=>`Bearer ${token}`,
    strict: true
})), Schema);
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
